import { getAnalyticsActor, posthog } from './posthog'

/** Nơi mở truy xuất nguồn gốc lô: hộp thoại của đơn, hoặc chi tiết lô Kho bán hàng. */
export type LotTraceSource = 'order' | 'sales_lot'

/**
 * Mỗi lần tải xong (hoặc lỗi) phả hệ một lô thành phẩm (M-179). Chỉ gửi enum
 * và cờ có/không có ngày sản xuất: KHÔNG gửi mã lô, tên sản phẩm hay ngày.
 * Analytics lỗi hoặc tắt không được chặn việc xem truy xuất.
 */
export function captureLotTraceView(
    input:
        | {
              source: LotTraceSource
              outcome: 'loaded'
              hasManufacturedDate: boolean
          }
        | { source: LotTraceSource; outcome: 'error' },
) {
    try {
        const actor = getAnalyticsActor()
        if (!actor) return
        posthog.capture('lot_trace_view', {
            schema_version: 1,
            event_id: crypto.randomUUID(),
            ...actor,
            source: input.source,
            outcome: input.outcome,
            ...(input.outcome === 'loaded'
                ? { has_manufactured_date: input.hasManufacturedDate }
                : {}),
        })
    } catch {
        // Analytics không được chặn việc xem truy xuất.
    }
}
